export default "__VITE_ASSET__dd15ed02__"